<template>
  <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
    <div class="col-12 mb-4">
      <v-card elevation="0">
         <div class="mt-3 mb-0 pb-0">
                <v-alert type="info">
                    {{ $t('business_entry')}} {{ $t('business_note1') }}
                </v-alert>
            </div>
      <!-- Generation de lien de paiement pour multiple payment -->
       <div>
         <v-form>
           <v-row>
             <v-col lg="4" sm="6">
               <router-link :to="{name: 'customers'}" class="box-business">
                 <img src="/images/client.png" alt="intram-product">
                 <h4>{{ $t('menus.customers') }}</h4>
               </router-link>
             </v-col>

             <v-col lg="4" sm="6">
               <router-link :to="{name: 'products'}" class="box-business">
                 <img src="/images/product.ico" alt="intram-client">
                 <h4>{{ $t('menus.products') }}</h4>
               </router-link>
             </v-col>

             <v-col lg="4" sm="6">
               <router-link :to="{name: 'marchandScheduleTransact'}" class="box-business">
                 <img src="/images/transaction.png" alt="intram-transaction">
                 <h4>{{ $t('menus.transactions') }}</h4>
               </router-link>
             </v-col>
            
         <!--    <v-col lg="4" sm="6">
               <router-link :to="'/'" class="box-business">
                 <img src="/images/stats.ico" alt="intram-transaction">
                 <h4>{{ $t('menus.stats') }}</h4>
               </router-link>
             </v-col> -->

           </v-row>
           
         </v-form>
       </div>
       <v-col>
      
       </v-col>
      </v-card>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  label: "intramBusiness",
  data() {
    return {
      dialogDeleteCategory: false,
      products_tabs: []
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getProductCategories()
      if (this.$store.getters.marchand)
        this.getMarchanProducts()

    },
    checkisDashboard() {
      this.$emit('checkisDashboard', true);
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize()
  }
}
</script>

<style scoped>
.box-business img{
  width: 200px;
  margin-bottom: 20px;
}
.box-business:hover{
  transition-duration: 500ms;
  transition-property: background-color;
  background-color: #ccc;
}
.box-business h4{
  text-decoration: none;
  
}
.box-business{
  display: block;
  background: #fff;
  text-align: center;
  padding: 30px;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgb(39 48 57 / 5%);
  border-radius: 8px;
}
</style>
